import React from "react";

function NoticeBar() {
  const items = [
    { label: "Fee Structure", href: "/Fee structure (1).pdf" },
    { label: "Affiliation Copy", href: "/Affiliation copy latest (1).pdf" },
    { label: "Student List", href: "/Students List for the Academic Year (1).pdf" },
    { label: "Teacher List", href: "/Teachers Details (1).pdf" },
    { label: "Facilities Available", href: "/Facilities available (1).pdf" },
  ];
  return (
    <div className="notice-bar">
      <div className="notice-track">
        {items.concat(items).map((it, idx) => (
          <a
            key={idx}
            className="notice-link"
            href={it.href}
            target="_blank"
            rel="noreferrer"
          >
            {it.label}
          </a>
        ))}
      </div>
    </div>
  );
}

export default function Home() {
  return (
    <>
      <div id="homeCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1" />
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="1" aria-label="Slide 2" />
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="2" aria-label="Slide 3" />
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="3" aria-label="Slide 4" />
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="4" aria-label="Slide 5" />
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src="/img/i12.jpg" className="d-block w-100" alt="Slide 1" />
          </div>
          <div className="carousel-item">
            <img src="/img/i13.jpg" className="d-block w-100" alt="Slide 2" />
          </div>
          <div className="carousel-item">
            <img src="/img/i14.jpg" className="d-block w-100" alt="Slide 3" />
          </div>
          <div className="carousel-item">
            <img src="/img/i15.jpg" className="d-block w-100" alt="Slide 4" />
          </div>
          <div className="carousel-item">
            <img src="/img/i16.jpg" className="d-block w-100" alt="Slide 5" />
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#homeCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#homeCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      <NoticeBar />

      <div className="container my-4">
        <h3>Welcome to Shri Ghanamatheshwar College of Education (B.Ed.)</h3>
        <p>
          At Shri Ghanamatheshwar College of Education (B.Ed.), we are committed to nurturing future educators who can shape the minds of tomorrow. Our institution, recognized for academic excellence and a holistic approach to education, provides aspiring teachers with the knowledge, skills, and values necessary to thrive in the evolving field of education.
        </p>
        <p>
          We believe that education is not just about imparting knowledge, but about inspiring lifelong learners who will make a lasting impact in their classrooms and communities.
        </p>
        <p>
          With a well-structured curriculum, an experienced faculty, and a range of modern teaching resources, our college offers a transformative educational experience. We focus on blending theoretical foundations with practical teaching experience, ensuring that our graduates are prepared for real-world classroom environments.
        </p>

        <div className="row mt-4">
          <div className="col-md-6">
            <h5>Quote By Swami Vivekananda</h5>
            <img src="/vivekanand.jpg" alt="Swami Vivekananda" className="img-fluid mb-2" />
            <p>Arise awake and stop not until the goal is reached.</p>
          </div>
          <div className="col-md-6">
            <h5>Quote By Dr. Sarvepalli Radhakrishnan</h5>
            <img src="/sarvapalli.jpg" alt="Dr. Sarvepalli Radhakrishnan" className="img-fluid mb-2" />
            <p>A life of joy and happiness is possible only on the basis of knowledge and science.</p>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <h5>News</h5>
            <ul>
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam in venenatis enim... <span>Read more...</span></li>
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam in venenatis enim... <span>Read more...</span></li>
            </ul>
          </div>
          <div className="col-md-6">
            <h5>Quick Links</h5>
            <ul>
              <li><a href="https://mhrd.gov.in" target="_blank" rel="noreferrer">MHRD</a></li>
              <li><a href="https://ncte.gov.in" target="_blank" rel="noreferrer">NCTE</a></li>
              <li><a href="https://www.ugc.ac.in" target="_blank" rel="noreferrer">UGC</a></li>
              <li><a href="https://www.rcub.ac.in" target="_blank" rel="noreferrer">RCUB</a></li>
              <li><a href="https://www.naac.gov.in" target="_blank" rel="noreferrer">NAAC</a></li>
              <li><a href="https://www.ncert.nic.in" target="_blank" rel="noreferrer">NCERT</a></li>
              <li><a href="https://www.dsert.kar.nic.in" target="_blank" rel="noreferrer">DSERT</a></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
